import { cssVar } from '@cad-arc';
import {
    ESRI_MAP_UNIT_LAYER_CLUSTER_MAX_SIZE,
    ESRI_MAP_UNIT_LAYER_CLUSTER_MIN_SIZE,
    ESRI_DEFAULT_ICON_LABEL_FONT,
} from '../configurations';
import type { FeatureReductionClusterProperties, LabelClassProperties } from '../types';
import { colors } from '../../colors/colors';

type ClusterConfigProps = {
    clusterRadius: number;
    labelExpression: string;
    clusterMinSize?: number;
    clusterMaxSize?: number;
    labelColor?: string;
    labelHaloColor?: string;
    haloSize?: string;
};

type FeatureReductionCluster = FeatureReductionClusterProperties & { type: 'cluster' };

export const getClusterConfig = ({
    clusterRadius,
    labelExpression,
    clusterMinSize,
    clusterMaxSize,
    labelColor,
    labelHaloColor,
    haloSize,
}: ClusterConfigProps): FeatureReductionCluster => {
    return {
        type: 'cluster',
        clusterRadius: `${clusterRadius}px`,
        clusterMinSize: `${clusterMinSize ?? ESRI_MAP_UNIT_LAYER_CLUSTER_MIN_SIZE}px`,
        clusterMaxSize: `${clusterMaxSize ?? ESRI_MAP_UNIT_LAYER_CLUSTER_MAX_SIZE}px`,
        labelingInfo: [
            {
                labelExpressionInfo: {
                    expression: labelExpression,
                },
                deconflictionStrategy: 'none',
                labelPlacement: 'center-center',
                symbol: {
                    type: 'text',
                    color: labelColor ?? colors.mapClusterLabel,
                    haloColor: labelHaloColor ?? colors.mapClusterLabelHalo,
                    haloSize: haloSize ?? '1px',
                    font: {
                        ...ESRI_DEFAULT_ICON_LABEL_FONT,
                        size: '16px',
                        weight: 'normal',
                    },
                },
            } as LabelClassProperties,
        ],
        symbol: {
            type: 'simple-marker',
            color: colors.mapClusterMarker,
        },
    };
};

export const createClusterContentInfoRow = ({
    labelInnerHTML,
}: {
    labelInnerHTML: string;
}): { row: HTMLDivElement; icon: HTMLImageElement; label: HTMLDivElement } => {
    const row = document.createElement('div');
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.height = '44px';
    row.style.cursor = 'pointer';

    // icon styles
    const icon = document.createElement('img');
    icon.style.height = '28px';
    icon.style.width = '28px';
    icon.style.marginRight = '8px';

    // label styles
    const label = document.createElement('div');
    label.style.fontFamily = 'proxima-nova';
    label.style.fontSize = '14px';
    label.style.fontWeight = '700';
    label.style.color = cssVar('arc.colors.raw.white');
    label.innerHTML = labelInnerHTML;

    // event listeners
    row.addEventListener('mouseenter', () => {
        row.style.background = colors.mapClusterHoverBackground;
    });
    row.addEventListener('mouseleave', () => {
        row.style.background = 'none';
    });

    return { row, icon, label };
};
